export enum FileType {
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio',
  DOCUMENT = 'document',
  OTHER = 'other',
  PDF = 'pdf',
}

export type LoadedFile = {
  id: string;
  file: File | null;
  name: string;
  extension: string;
  type: FileType;
  size: number;
  url?: string;
  error: string;
  loading?: boolean;
  uploaded?: boolean;
};

export type ProcessFileRules = {
  extension?: string;
  maxSize?: number;
  custom?: (file: File) => string | undefined | Promise<string | undefined>;
};
